import React, { useMemo, memo } from "react";

function ItemTable({ row, columns }) {
  return columns.map((column) => (
    <Item key={column.path || column.key} row={row} column={column} />
  ));
}

export default memo(ItemTable);

function Item({ row, column }) {
  const value = useMemo(() => {
    if (column.content) return column.content(row[column.path], row);
    return row[column.path] || "-";
  }, [row, column]);
  return (
    <div
      className={`item ${column.path} ${column.fixed ? "fixed" : ""}`}
      title={column.content ? null : value}
    >
      {value}
    </div>
  );
}
